export class Checker {
    // step = undefined;
    // final = undefined;
}
